import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=4b201edd&scoped=true"
import script from "./Meta.vue?vue&type=script&lang=js"
export * from "./Meta.vue?vue&type=script&lang=js"
import style0 from "./Meta.vue?vue&type=style&index=0&id=4b201edd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b201edd",
  null
  
)

export default component.exports